export enum ScrollLocation {
  CENTER = 'center',
  START = 'start'
}
